import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, FilterSection, SelectField, ToolbarComponent } from '../../../../../components'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { useDispatch, useSelector } from 'react-redux'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { ExportIcon, ImportIcon } from '../../../../../assets/icons'
import {
  setLoader,
  setOpenAddNewTimeTable,
  setOpenExportModal,
  setOpenImport,
  setOpenTransportModal,
} from '../../../../../redux/globalSlice'
import DashboardCard from '../../Dashboard/component/Card'
import NewSelectedField from '../../../../../common/NewSelectedField/NewSelectedField'
import NewTimeTable from './components/NewTimeTable/NewTimeTable'
import {
  generateTeacherTimeTableHeadCells,
  generateGradeTimeTableHeadCells,
} from '../../../../../shared/data/headCells'
import EmptyState from './TimeTableEmpty/EmptyState'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'

const TimeTable = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [page, setPage] = useState(1)
  const [day, setDay] = useState('Monday')
  const [viewedby, setViewedBy] = useState('Teacher')

  const dispatch = useDispatch()
  // console.log('----customRole',customRole);

  // const [openSchoolInfo, setSchoolInfo] = useState(false)
  const [search, setSearch] = useState('')
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)
  const addNewModal = useSelector((state) => state.global.openAddNewTimeTable)

  const [schoolName, setSchoolName] = React.useState('')
  // console.log('-----schoolName', schoolName)

  const {
    data: timeTableList,
    count,
    loading,
    refetch,
  } = useGlobal({
    userUrl: `${urls.TIMETABLE_VIEW_GET}?page=${page}&limit=${highestInt}&school_id=${customRole === 'Admin' ? userSchoolId : ''}&day=${day}&view=${viewedby}&keyword=${search}`,
  })

  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=${page}&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  // console.log('----timeTableList', timeTableList)

  //   const { data: searchstudent, count: searchcount } = useGlobal({
  //     userUrl: `${urls.STUDENT_SEARCH}${search}&grade_id=${selectedGrade}&fee_status=${feeStatus}&school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}`,
  //   })

  const rowData = timeTableList

  const handleOpen = () => {
    dispatch(setOpenAddNewTimeTable(true))
  }

  const no_data_msg =
    customRole == 'Admin'
      ? 'Add Student to start over'
      : schoolName
        ? 'Select school to see Students'
        : 'Select school to see Students'
  //   const pagecount = search ? searchcount : count

  const headCells = React.useMemo(() => {
    if (viewedby === 'Teacher') {
      return generateTeacherTimeTableHeadCells(timeTableList || [])
    } else {
      return generateGradeTimeTableHeadCells(timeTableList || [])
    }

    // Fallback / default when viewedby is something else (e.g. 'Class', 'Room', etc.)
    // You can customize this later based on what viewedby values you support
  }, [timeTableList, viewedby])
  const pagecount = count

  const handleExport = () => {
    if (rowData && rowData.length > 0) {
      downloadCSV(rowData, `TimeTable_${viewedby}_${day}`)
    } else {
      alert('No data to export')
    }
  }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Time Table Management'} subtitle={'Time Table'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => setSchoolName(selectedOption)}
              setPage={setPage}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>
      <ToolbarComponent
        handleOpen={handleOpen}
        width={'fit-content'}
        transport={true}
        search={search}
        setSearchItem={setSearch}
        timeTable
        setPage={setPage}
      >
        {/* <FilterStudent
          feeStatus={feeStatus}
          setFeeStatus={setFeeStatus}
          gradeValue={gradeValue}
          setGradeVal={setGradeVal}
          school_id={
            customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName
          }
        /> */}
        <NewSelectedField
          timeTable
          day={day}
          viewedby={viewedby}
          setDay={setDay}
          setViewedBy={setViewedBy}
        />

        {/* <ExportFile icon={FilterIcon} filename={'student'} jsonData={studentRow || []} /> */}
        <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />
        {/* <FilterSection
          icon={ExportIcon}
          onClick={() => dispatch(setOpenImport(true))}
          title={'Import'}
        /> */}
      </ToolbarComponent>
      {/* {search && !searchstudent && !rowData ? <TimeTableEmpty /> : <></>} */}
      {!rowData ? (
        !loading && <EmptyState />
      ) : loading ? (
        <></>
      ) : (
        <>
          <DataTable
            headCells={headCells}
            rowData={rowData}
            TeacherView={viewedby === 'Teacher' ? true : false}
            GradeView={viewedby !== 'Teacher' ? true : false}
            pages
            pageFee={page}
            noDataMsg={no_data_msg}
            setPageFee={setPage}
            school={false}
            search={search}
            pageCount={pagecount}
            // setUpdate={setUpdate}
            // count={count}
            // handleDetailOpen={() => setDetail(true)}
          />
        </>
      )}
      {addNewModal && (
        <NewTimeTable
          open={addNewModal}
          customRole={customRole}
          schoolList={schoolList}
          // schoolName={schoolName}
          userSchoolName={userSchoolName}
          userSchoolId={userSchoolId}
          day={day}
          refetch={refetch}
        />
      )}
    </div>
  )
}

export default TimeTable
